import { render, staticRenderFns } from "./onlinelearn.vue?vue&type=template&id=4f789091&scoped=true"
import script from "./onlinelearn.vue?vue&type=script&lang=js"
export * from "./onlinelearn.vue?vue&type=script&lang=js"
import style0 from "./onlinelearn.vue?vue&type=style&index=0&id=4f789091&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f789091",
  null
  
)

export default component.exports